exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".indented[data-v-88355c96]{margin:20px;max-width:550px}.spacer[data-v-88355c96]{height:15px;border:0 solid #000}.spaced[data-v-88355c96]{margin-bottom:10px}.button[data-v-88355c96]{border:1px solid gray}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-88355c96","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/Comp_AddSubcat.vue
// module id = 152
// module chunks = 0